import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CallIcon: FC<Props> = (props) => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="call icon">
      {/* <title>call icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.08586 6.12633C5.08819 6.12633 5.02986 6.187 4.95636 6.25933C4.67403 6.5335 4.08952 7.104 4.08363 8.2975C4.07436 9.967 5.17219 13.0668 10.4584 18.3518C15.72 23.6112 18.8152 24.7218 20.4882 24.7218H20.5127C21.7062 24.716 22.2755 24.1303 22.5509 23.8492C22.6349 23.7628 22.7025 23.6998 22.7504 23.6602C23.9124 22.4912 24.5074 21.6208 24.5016 21.0632C24.4934 20.4938 23.7852 19.8207 22.8064 18.8897C22.4949 18.5933 22.1565 18.2713 21.7995 17.9143C20.8744 16.9915 20.4159 17.149 19.4079 17.5037C18.0137 17.9925 16.1004 18.6575 13.1277 15.6837C10.1504 12.7087 10.8165 10.7977 11.3042 9.4035C11.6565 8.3955 11.8175 7.93583 10.8912 7.0095C10.5284 6.64783 10.2029 6.30483 9.90302 5.98983C8.97786 5.01683 8.31052 4.31333 7.74469 4.30516H7.73536C7.17652 4.30516 6.30852 4.9025 5.08002 6.131C5.08352 6.1275 5.08586 6.12633 5.08586 6.12633ZM20.4894 26.4718C17.582 26.4718 13.7915 24.1572 9.22169 19.5897C4.63436 15.0035 2.31619 11.2013 2.33359 8.28816C2.34419 6.36316 3.35336 5.37733 3.73252 5.0075C3.75236 4.983 3.82002 4.9165 3.84336 4.89316C5.51636 3.219 6.64452 2.54233 7.76686 2.55498C9.07002 2.57266 9.99752 3.548 11.1712 4.7835C11.4617 5.08916 11.7767 5.42166 12.1279 5.77166C13.8312 7.475 13.3459 8.8645 12.9562 9.97983C12.5315 11.1967 12.164 12.2467 14.3644 14.447C16.567 16.6473 17.617 16.2798 18.8292 15.8517C19.9457 15.462 21.3317 14.9743 23.0374 16.6777C23.3827 17.023 23.7105 17.3345 24.0127 17.6227C25.254 18.8022 26.234 19.7343 26.2506 21.041C26.2644 22.1552 25.5877 23.2903 23.917 24.9622L23.1774 24.4605L23.8027 25.0718C23.4329 25.451 22.4482 26.4613 20.522 26.4718H20.4894Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
    </svg>
  );
};

export default CallIcon;
